import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import PropTypes from 'prop-types'
import HeaderEmpty from 'letter/components/header/header_empty'
import HeaderDisplay from 'letter/components/header/header_display'
import HeaderEdit from 'letter/components/header/header_edit'
import { letterHeaderStates } from 'base/util/constants'
import { setOverlayOnDocument } from 'transaction/util/setOverlayOnDocument'
import { removeOverlayFromDocument } from 'transaction/util/removeOverlayFromDocument'
import { isEqual } from 'lodash'

const {
  LETTER_HEADER_EMPTY_STATE,
  LETTER_HEADER_DISPLAY_STATE,
  LETTER_HEADER_EDIT_STATE,
} = letterHeaderStates
const CONTAINER_CLASS = '.headerWrapper'

class HeaderClass extends React.Component {
  constructor(props) {
    super(props)
    const { items, isHeaderEdit } = props

    this.state = {
      items,
      headerState: isHeaderEdit
        ? LETTER_HEADER_EDIT_STATE
        : items.length > 0
          ? LETTER_HEADER_DISPLAY_STATE
          : LETTER_HEADER_EMPTY_STATE,
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props && !isEqual(this.props, prevProps)) {
      if (this.props.items && this.props.items.length !== this.state.items.length) {
        this.setState({ ...prevState, items: this.props.items })
      }
    }
  }

  handleSaveSuccess({ items, fabricObjects }) {
    this.setState({
      items,
      fabricObjects,
      headerState: items.length > 0
        ? LETTER_HEADER_DISPLAY_STATE
        : LETTER_HEADER_EMPTY_STATE,
    }, () => {
      removeOverlayFromDocument(CONTAINER_CLASS)
    })
  }

  onCancelEditMode() {
    const { items } = this.state
    this.setState({
      headerState: items.length > 0
        ? LETTER_HEADER_DISPLAY_STATE
        : LETTER_HEADER_EMPTY_STATE,
    }, () => {
      removeOverlayFromDocument(CONTAINER_CLASS)
    })
  }

  onHeaderEmptyClick() {
    setOverlayOnDocument(CONTAINER_CLASS)
    this.setState({ headerState: LETTER_HEADER_EDIT_STATE })
  }

  onHeaderDisplayClick() {
    setOverlayOnDocument(CONTAINER_CLASS)
    this.setState({ headerState: LETTER_HEADER_EDIT_STATE })
  }

  onHeaderClick(event) {
    const e = event.nativeEvent
    e.stopPropagation()
    e.stopImmediatePropagation()
  }

  save() {
    if (this.headerEditRef && this.headerEditRef.onButtonSave) {
      return this.headerEditRef.onButtonSave()
    }
  }

  render() {
    const { model, collection, showSaveButton = true } = this.props
    const { items, headerState } = this.state
    let activeComponent

    switch (headerState) {
      case LETTER_HEADER_DISPLAY_STATE:
        activeComponent = <HeaderDisplay items={items} onClick={this.onHeaderDisplayClick.bind(this)} />
        break
      case LETTER_HEADER_EMPTY_STATE:
        activeComponent = <HeaderEmpty onClick={this.onHeaderEmptyClick.bind(this)} />
        break
      case LETTER_HEADER_EDIT_STATE:
        activeComponent = (<HeaderEdit
          ref={ref => { this.headerEditRef = ref }}
          parent={parent}
          showSaveButton={showSaveButton}
          model={model}
          items={items}
          collection={collection}
          onCancelEditMode={this.onCancelEditMode.bind(this)}
          onSuccess={this.handleSaveSuccess.bind(this)}
          isHeaderEdit />)
        break
    }

    return (
      <div className='headerWrapper' onClick={this.onHeaderClick}>
        {headerState !== LETTER_HEADER_EDIT_STATE
          ? <div className='headerContainer header'>{activeComponent}</div>
          : activeComponent
        }
      </div>
    )
  }
}

HeaderClass.propTypes = {
  model: PropTypes.object,
  collection: PropTypes.object,
  items: PropTypes.array,
  headerState: PropTypes.bool,
  isHeaderEdit: PropTypes.bool,
}

const Header = forwardRef((props, ref) => {
  const internalRef = useRef()

  useImperativeHandle(ref, () => ({
    save: () => {
      if (internalRef.current) {
        return internalRef.current.save()
      }
    },
  }))

  return <HeaderClass {...props} ref={internalRef} />
})

export default Header
